export const evalVisibleConditions = (
  values: Record<string, unknown>,
  conditions: Record<string, string> = {},
  sources: string[] | undefined,
) => {
  for (const key in conditions) {
    if (sources && !sources.includes(key)) return true;
    try {
      const condition = conditions[key];
      const value = values[key];
      const isVisible = new Function(
        "value",
        "values",
        `return (${condition})`,
      )(value, values);
      if (!isVisible) return false;
    } catch {
      return false;
    }
  }

  return true;
};
